import { applyIosVideoAttrs } from './videoAttrs';

let registered = false;

/** One-shot iOS Low Power Mode / autoplay-policy unlock on first user gesture. */
export function registerGestureUnlock() {
  if (registered || typeof document === 'undefined') return;
  registered = true;

  const unlock = () => {
    document.querySelectorAll('video').forEach((video) => {
      applyIosVideoAttrs(video);
      void video.play().catch(() => {});
    });
    document.removeEventListener('pointerdown', unlock, true);
    document.removeEventListener('touchstart', unlock, true);
  };

  document.addEventListener('pointerdown', unlock, true);
  document.addEventListener('touchstart', unlock, true);
}
